import React from 'react';
import { useIntl } from 'react-intl';

import { TranslationKeys } from 'app/translations';
import { ContractTypeEnum } from '../types/employee.types';

export const useContractTypeSelectItems = () => {
  const intl = useIntl();

  const contractTypeSelectItems = React.useMemo(() => {
    return [
      {
        element: intl.formatMessage({ id: TranslationKeys.global_contractType_intern }),
        label: intl.formatMessage({ id: TranslationKeys.global_contractType_intern }),
        value: ContractTypeEnum.Intern,
      },
      {
        element: intl.formatMessage({ id: TranslationKeys['global_contractType_employment-contract'] }),
        label: intl.formatMessage({ id: TranslationKeys['global_contractType_employment-contract'] }),
        value: ContractTypeEnum.EmploymentContract,
      },
      {
        element: intl.formatMessage({ id: TranslationKeys['global_contractType_temporary-worker'] }),
        label: intl.formatMessage({ id: TranslationKeys['global_contractType_temporary-worker'] }),
        value: ContractTypeEnum.TemporaryWorker,
      },
      {
        element: intl.formatMessage({ id: TranslationKeys.global_contractType_other }),
        label: intl.formatMessage({ id: TranslationKeys.global_contractType_other }),
        value: ContractTypeEnum.Other,
      },
    ];
  }, [intl]);

  const getContractTypeDisplayNameByValue = React.useCallback(
    (value: ContractTypeEnum) => {
      return contractTypeSelectItems.find(contractType => contractType.value === value)?.element;
    },
    [contractTypeSelectItems],
  );

  return { contractTypeSelectItems, getContractTypeDisplayNameByValue };
};
